import { TextButton } from '@zillow/constellation-10';

interface SecondaryCTAProps {
  onClick: () => void;
  recurring: boolean;
}

const SecondaryCTA = ({ onClick, recurring }: SecondaryCTAProps) => (
  <TextButton css={{ marginTop: 'tighter' }} onClick={onClick}>
    {recurring ? 'Cancel all payments' : 'Cancel payment'}
  </TextButton>
);

export default SecondaryCTA;
